export const getCountries = state => state.config.countries

export const getIsConfigLoaded = state => state.config.isConfigLoaded

export const getCPV = state => state.config.CPV

export const getDocuments = state => state.config.documents

export const getSearchConfig = state => {
  const CPVs = getCPV(state) || []
  const countries = getCountries(state) || []
  const spain = countries.find(country => country.code === 'ES')
  const provinces = spain ? spain.states : []
  const documents = getDocuments(state)
  const requirements = state.auth.user.companyInfo.own_documents || []
  const vendorTypes = state.auth.user.companyInfo.vendor_types || []

  return { CPVs, countries, provinces, documents, requirements, vendorTypes }
}
